var map = {
	"./betalkort-maestro.png": 3011,
	"./betalkort-mastercard.png": 2552,
	"./betalkort-visa.png": 4016,
	"./logo-bolagsverket-en.svg": 397,
	"./logo-bolagsverket.svg": 8686,
	"./swish.png": 8333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7007;